<template>
  <div class="kehufengxiandengjiceping-shuoming">
    <AiLoading :visible="loading" title="正在生成专属风险测评方案" :yujishijian="yujishijian"></AiLoading>

    <div class="header">
      <div class="title-row">
        <svg class="shield-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <h1>客户风险等级测评</h1>
      </div>
      <p class="subtitle">了解您的风险偏好，为您提供更合适的投资建议</p>
    </div>

    <div class="feature-cards">
      <div class="feature-card">
        <div class="feature-icon-wrapper">
          <svg class="feature-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="9" x2="15" y2="9" />
            <line x1="9" y1="15" x2="15" y2="15" />
            <line x1="9" y1="12" x2="15" y2="12" />
          </svg>
        </div>
        <div class="feature-count">15题</div>
        <div class="feature-label">精选题目</div>
      </div>

      <div class="feature-card">
        <div class="feature-icon-wrapper">
          <svg class="feature-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <div class="feature-count">预计3-5分钟</div>
        <div class="feature-label">快速完成</div>
      </div>

      <div class="feature-card">
        <div class="feature-icon-wrapper">
          <svg class="feature-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="23" />
            <line x1="8" y1="23" x2="16" y2="23" />
          </svg>
        </div>
        <div class="feature-count">语音+文字</div>
        <div class="feature-label">双模式</div>
      </div>

      <div class="feature-card">
        <div class="feature-icon-wrapper">
          <svg class="feature-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 20V10" />
            <path d="M12 20V4" />
            <path d="M6 20v-6" />
          </svg>
        </div>
        <div class="feature-count">输出C1-C5</div>
        <div class="feature-label">风险等级</div>
      </div>
    </div>

    <div class="info-bar">
      <svg class="info-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      <span>测评结果将用于为您进行资产配置与投资组合推荐，用于实训场景</span>
    </div>

    <div class="footer">
      <button class="start-btn common-btn" id="btn-start-voice-quiz" @click="handleStart">
        开始测评
        <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import AiLoading from '@/components/AiLoading.vue'
export default {
  name: 'KehufengxiandengjicepingShuoming',
  components: {
    AiLoading
  },
  data () {
    return {
      studentId: '',
      loading: false,
      yujishijian: ''
    }
  },
  watch: {
    loading (val) {
      localStorage.setItem('shuoming_loading', JSON.stringify({ visible: val, yujishijian: this.yujishijian }))
    }
  },
  created () {
    // 强制重置 loading，防止上一轮异常残留导致卡死
    this.loading = false
    localStorage.removeItem('shuoming_loading')
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    this.loading = false
    localStorage.removeItem('shuoming_loading')
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange (event) {
      if (event.key === 'shuoming_loading' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          this.loading = data.visible
          this.yujishijian = data.yujishijian || ''
        } catch (e) { /* ignore */ }
      }
    },
    handleStart () {
      this.yujishijian = `，预计时间：${Math.floor(Math.random() * 31 + 30)}秒...`
      this.loading = true
      apiOpen.VisitorQuestions().then(res => {
        console.log("获取测评题目成功：", res)
        // 这里可以添加开始测评的逻辑
        this.loading = false
        // 同时存储到 sessionStorage 和 localStorage（支持跨标签页共享）
        sessionStorage.setItem('questions', JSON.stringify(res.questions))
        localStorage.setItem('questions', JSON.stringify(res.questions))
        this.$router.push({ name: 'Ceping' });
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.$message.error(err.message)
      })
    },
    handleStart2 () {
      this.loading = true
      apiOpen.KYCQuestionnaire({ studentId: this.studentId }).then(res => {
        console.log("获取测评题目成功：", res)
        // 这里可以添加开始测评的逻辑
        this.loading = false
        // 同时存储到 sessionStorage 和 localStorage（支持跨标签页共享）
        sessionStorage.setItem('questions', JSON.stringify(res.questions))
        localStorage.setItem('questions', JSON.stringify(res.questions))
        this.$router.push({ name: 'Ceping' });
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.$message.error(err.message)
      })
    }
  }
}
</script>

<style scoped lang="less">
.kehufengxiandengjiceping-shuoming {
  min-height: 100vh;
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header {
  text-align: center;
  margin-bottom: 48px;
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.shield-icon {
  color: #3b82f6;
  background: white;
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.25);
}

.header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 720px;
  margin-bottom: 32px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 20px;
}

.feature-card {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  transition: all 0.25s ease;
}

.feature-card:hover {
  background: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.feature-icon-wrapper {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon {
  color: #3b82f6;
}

.feature-count {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.feature-label {
  font-size: 13px;
  color: #64748b;
}

.info-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(59, 130, 246, 0.08);
  border-radius: 24px;
  margin-bottom: 40px;
}

.info-icon {
  color: #3b82f6;
  flex-shrink: 0;
}

.info-bar span {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

.footer {
  width: 100%;
  max-width: 480px;
}

.start-btn {
  width: 100%;
  padding: 16px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  // background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  // border: none;
  border-radius: 12px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  gap: 8px;
  transition: all 0.25s ease;
  // box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
}

.start-btn:hover {
  transform: translateY(-2px);
  // box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
}

.start-btn:active {
  transform: translateY(0);
}

.arrow-icon {
  color: white;
}

@media (max-width: 900px) {
  .feature-cards {
    grid-template-columns: repeat(2, 1fr);
    max-width: 480px;
  }
}

@media (max-width: 600px) {
  .kehufengxiandengjiceping-shuoming {
    padding: 32px 20px;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    justify-content: flex-start;
    padding-top: 60px;
  }

  .header {
    margin-bottom: 32px;
  }

  .title-row {
    gap: 10px;
  }

  .shield-icon {
    width: 34px;
    height: 34px;
    padding: 6px;
  }

  .header h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
  }

  .feature-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-bottom: 24px;
  }

  .feature-card {
    padding: 20px 12px;
    border-radius: 12px;
  }

  .feature-icon-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 12px;
  }

  .feature-icon {
    width: 24px;
    height: 24px;
  }

  .feature-count {
    font-size: 16px;
  }

  .feature-label {
    font-size: 12px;
  }

  .info-bar {
    padding: 10px 16px;
    border-radius: 20px;
    margin-bottom: 28px;
  }

  .info-bar span {
    font-size: 12px;
  }

  .footer {
    max-width: 100%;
  }

  .start-btn {
    padding: 14px;
    font-size: 16px;
    border-radius: 10px;
  }
}

@media (max-width: 400px) {
  .kehufengxiandengjiceping-shuoming {
    padding: 24px 16px;
    padding-top: 48px;
  }

  .feature-cards {
    gap: 10px;
  }

  .feature-card {
    padding: 16px 10px;
  }

  .feature-icon-wrapper {
    width: 38px;
    height: 38px;
  }

  .feature-icon {
    width: 22px;
    height: 22px;
  }

  .feature-count {
    font-size: 14px;
  }

  .feature-label {
    font-size: 11px;
  }

  .info-bar {
    padding: 8px 12px;
  }

  .info-bar span {
    font-size: 11px;
  }

  .start-btn {
    padding: 12px;
    font-size: 15px;
  }
}
</style>
